/**
 * Gate label formatting — mirrors the textual convention used in the
 * spec's confirmation copy. <c>StageFrom = null</c> renders as
 * "(any) → StageTo" so the catalog reads consistently regardless of
 * whether the gate is bound to a specific source stage.
 */
export function formatGate(stageFrom: string | null, stageTo: string): string {
  return `${stageFrom ?? "(any)"} → ${stageTo}`;
}
